import { render } from "./mobile.vue?vue&type=template&id=4b54f89c&ts=true"
import script from "./mobile.vue?vue&type=script&lang=ts"
export * from "./mobile.vue?vue&type=script&lang=ts"

import "./mobile.vue?vue&type=style&index=0&id=4b54f89c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__